import React, { useEffect } from 'react';
import { useRouter } from 'next/router';
import Head from 'next/head';
import { onIdTokenChanged } from 'firebase/auth';

import Navbar from '../../components/Navbars/AppNavbar.js';
import Footer from '../../components/Footers/Footer.js';
import FooterSM from '../../components/Footers/FooterSmall.js';
import CollectionComponent from '../../components/Collection/index';
import { firebaseAuthFunc } from '../../config/firebaseAuth.js';
// const CollectionComponent = dynamic(import("../../components/Collection/index"), {ssr:false})

export default function Collection() {
  const router = useRouter();

  useEffect(() => {
    onIdTokenChanged(firebaseAuthFunc, (user, err) => {
      if (!user) {
        router.push('/auth/login?page=collection');
      }
    });
  }, []);

  return (
    <>
      <Head>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, shrink-to-fit=no"
        />
        <link rel="canonical" href="https://musicart.io/collection" />
      </Head>

      <div className="relative bg-blueGray-100 ">
        <Navbar transparent />
        <div style={{ minHeight: '70vh' }}>
          <CollectionComponent />
        </div>
        <Footer />
        <FooterSM />
      </div>
    </>
  );
}
